import { SUBSCRIPTION_ACTION_TYPES } from "../actionTypes";

const initialState = {
  error: "",
  identified: false,
  // profile: {}
  profile: {
    guid: "somerandomvalue",
    nickname: "Test User 1"
  },
  // profiles: []
  profiles: [
    {
      guid: "somerandomvalue",
      nickname: "Test User 1"
    },
    {
      guid: "somerandomvalue",
      nickname: "Test User 2"
    },
    {
      guid: "somerandomvalue",
      nickname: "Test User 3"
    }
  ]
};

const UserProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_USER:
      return {
        ...state,
        identified: action.payload,
        error: ""
      };
    case SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
        error: ""
      };
    case SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_PROFILES:
      return {
        ...state,
        identified: false,
        profile: {},
        // profiles: action.payload,
        error: ""
      };
    case SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.ERROR:
      return {
        ...state,
        identified: false,
        profiles: [],
        error: action.payload
      };
    default:
      return state;
  }
};

export default UserProfileReducer;
